import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshancab() {



  const cardData = {




keyword: "Pune to Ashtavinayak Darshan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Ashtavinayak Darshan Cab Service for devotees, families, senior citizens, couples, and groups planning a complete Ashtavinayak pilgrimage from Pune. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for multi-temple journeys covering the eight revered Lord Ganesha temples across Maharashtra. The cab service is suitable for customized one-day or multi-day pilgrimage plans, with flexible pickup locations, experienced drivers, comfortable seating, spacious luggage areas, and convenient temple-to-temple transportation. With well-maintained vehicles, transparent pricing, customized travel schedules, and 24/7 customer assistance, Garud Cab Service makes the Ashtavinayak Darshan journey from Pune comfortable, organized, and convenient.",

topPlaces: [
  {
    title: "Morgaon",
    description: "Morgaon is home to the famous Mayureshwar Temple and is traditionally considered the starting and concluding point of the Ashtavinayak pilgrimage. Devotees visit the temple to seek the blessings of Lord Ganesha and complete important pilgrimage rituals. Garud Cab Service provides convenient private transportation from Pune with flexible darshan schedules."
  },
  {
    title: "Siddhatek",
    description: "Siddhatek is an important Ashtavinayak pilgrimage destination known for the Siddhivinayak Temple dedicated to Lord Ganesha. The temple is located near the Bhima River and attracts devotees throughout the year. Customers can include Siddhatek in their customized Ashtavinayak cab itinerary with comfortable transportation between pilgrimage locations."
  },
  {
    title: "Pali",
    description: "Pali is known for the Ballaleshwar Temple, one of the eight Ashtavinayak temples in Maharashtra. The temple has strong religious importance and is visited by families and devotees from different parts of the state. Garud Cab Service offers chauffeur-driven cabs for convenient travel to Pali as part of a complete Ashtavinayak Darshan tour."
  },
  {
    title: "Mahad",
    description: "Mahad is home to the Varadvinayak Temple, an important stop on the Ashtavinayak pilgrimage circuit. Devotees visit the temple for religious blessings and peaceful darshan. Travelers from Pune can book a private cab with flexible schedules and combine Mahad with the remaining Ashtavinayak temples according to their preferred route."
  },
  {
    title: "Theur",
    description: "Theur is a prominent pilgrimage destination near Pune and is home to the Chintamani Temple, one of the revered Ashtavinayak temples. The temple is dedicated to Lord Ganesha and is visited frequently by devotees. Garud Cab Service provides convenient cab transportation from Pune and can include Theur as part of a complete pilgrimage itinerary."
  },
  {
    title: "Lenyadri",
    description: "Lenyadri is a unique Ashtavinayak destination where the Girijatmaj Temple is located within a group of ancient rock-cut caves. Devotees and history enthusiasts visit the site for its religious and archaeological significance. Customers can travel comfortably by private cab and plan sufficient time for the temple visit and surrounding attractions."
  },
  {
    title: "Ozar",
    description: "Ozar is home to the Vighneshwar Temple, one of the important temples included in the Ashtavinayak pilgrimage. The temple is known for its traditional architecture and peaceful religious atmosphere. Garud Cab Service provides comfortable transportation for families and groups traveling from Pune and can coordinate the temple visit with other pilgrimage stops."
  },
  {
    title: "Ranjangaon",
    description: "Ranjangaon is known for the Mahaganapati Temple and is an important destination on the Ashtavinayak pilgrimage route. Devotees visit the temple throughout the year for darshan and religious ceremonies. Customers can book a chauffeur-driven cab from Pune and include Ranjangaon conveniently within a customized Ashtavinayak Darshan schedule."
  },
  {
    title: "Shirur",
    description: "Shirur is an important town along the Pune-Ranjangaon side of the Ashtavinayak travel route and can serve as a convenient stop for refreshments, local requirements, or onward travel. Customers planning a multi-day pilgrimage can use private cab transportation to maintain a comfortable schedule between temple destinations."
  },
  {
    title: "Junnar",
    description: "Junnar is a historic region near the Lenyadri and Ozar pilgrimage locations and is known for ancient caves, forts, temples, and scenic Sahyadri surroundings. Travelers completing Ashtavinayak Darshan can include nearby attractions around Junnar when time permits. Garud Cab Service provides flexible multi-destination cab arrangements for customized pilgrimage tours."
  }
],




"services": [
{
"name": "Pune to Ashtavinayak Cab",
"description": "Book Pune to Ashtavinayak Cab for comfortable private transportation to the famous Ashtavinayak temples of Maharashtra. The service is suitable for devotees, families, senior citizens, and groups looking for convenient chauffeur-driven travel with flexible pilgrimage arrangements."
},
{
"name": "Ashtavinayak Darshan Cab Pune",
"description": "Choose Ashtavinayak Darshan Cab Pune for convenient private transportation covering the important Ashtavinayak temples. Comfortable AC vehicles and professional chauffeurs make the journey suitable for families, devotees, senior passengers, and religious groups."
},
{
"name": "Pune Ashtavinayak Taxi Service",
"description": "Book Pune Ashtavinayak Taxi Service for comfortable pilgrimage transportation from Pune to multiple Ganesh temples. Sedan, SUV, Innova, and larger vehicles can be arranged according to passenger count, luggage, itinerary, and travel duration."
},
{
"name": "Cab for Ashtavinayak Yatra Pune",
"description": "Choose Cab for Ashtavinayak Yatra Pune for private transportation during your planned temple journey. The service provides convenient pickup, comfortable road travel, and professional driver assistance for families and groups completing their Ashtavinayak pilgrimage."
},
{
"name": "Pune to Ashtavinayak Tour Cab",
"description": "Book Pune to Ashtavinayak Tour Cab for a convenient temple tour covering selected or all Ashtavinayak destinations. The service is suitable for devotees, families, tourists, and groups seeking flexible private transportation throughout their religious journey."
},
{
"name": "Ashtavinayak Darshan Taxi Pune",
"description": "Choose Ashtavinayak Darshan Taxi Pune for comfortable chauffeur-driven travel between the Ashtavinayak temples. Spacious vehicles can be selected for families, senior citizens, devotees, and groups according to their pilgrimage schedule and passenger requirements."
},
{
"name": "Pune Religious Cab Ashtavinayak",
"description": "Book Pune Religious Cab Ashtavinayak for private transportation dedicated to religious and pilgrimage travel. Comfortable AC vehicles with experienced chauffeurs provide convenient travel for devotees visiting multiple Ganesh temples from Pune."
},
{
"name": "Pune Temple Darshan Cab",
"description": "Choose Pune Temple Darshan Cab for convenient private transportation to Ashtavinayak and other temple destinations around Maharashtra. The service is suitable for families, senior passengers, devotees, and groups planning organized religious sightseeing."
},
{
"name": "One Day Ashtavinayak Cab Pune",
"description": "Book One Day Ashtavinayak Cab Pune for a planned single-day pilgrimage journey covering selected Ashtavinayak temples. The service is suitable for devotees and families who prefer private transportation with an experienced chauffeur and an organized travel schedule."
},
{
"name": "Pune Pilgrimage Cab Ashtavinayak",
"description": "Choose Pune Pilgrimage Cab Ashtavinayak for comfortable transportation during a religious temple tour. Vehicle options can be arranged according to group size, luggage, and itinerary, making the service suitable for families, devotees, and senior citizens."
},
{
"name": "Best Ashtavinayak Cab Pune",
"description": "Book the Best Ashtavinayak Cab Pune for a comfortable pilgrimage experience with professional chauffeurs and well-maintained vehicles. The service is suitable for families, groups, senior devotees, and travelers planning a private Ashtavinayak temple tour."
},
{
"name": "SUV Ashtavinayak Cab Pune",
"description": "Choose SUV Ashtavinayak Cab Pune for spacious and comfortable temple tour transportation with additional seating and luggage capacity. SUVs are suitable for families, small groups, and devotees planning longer road journeys across multiple destinations."
},
{
"name": "Innova Ashtavinayak Cab Pune",
"description": "Book Innova Ashtavinayak Cab Pune for spacious private transportation suitable for families and small pilgrimage groups. The vehicle provides comfortable seating and practical luggage space for multi-temple travel and extended road journeys."
},
{
"name": "Sedan Ashtavinayak Cab Pune",
"description": "Choose Sedan Ashtavinayak Cab Pune for comfortable AC transportation for individuals, couples, and small families. Sedan travel is suitable for temple visits, one-day pilgrimage trips, and customized Ashtavinayak journeys."
},
{
"name": "Ashtavinayak Yatra Booking Pune",
"description": "Make Ashtavinayak Yatra Booking Pune to arrange a private vehicle and planned transportation for your pilgrimage. Customers can select suitable cars or larger vehicles according to their group size, travel duration, temple itinerary, and luggage requirements."
},
{
"name": "Pune to Ashtavinayak One-Day Trip",
"description": "Book Pune to Ashtavinayak One-Day Trip for a planned pilgrimage journey from Pune with private chauffeur-driven transportation. The service is suitable for devotees and families who want to visit selected temples within a single-day travel schedule."
},
{
"name": "One-Day Ashtavinayak Cab Package",
"description": "Choose One-Day Ashtavinayak Cab Package for convenient private transportation during a scheduled one-day temple tour. Comfortable vehicles and professional drivers can be arranged according to the selected itinerary, passenger count, and travel requirements."
},
{
"name": "Ashtavinayak Darshan in One Day from Pune",
"description": "Book Ashtavinayak Darshan in One Day from Pune for a private road journey planned around your selected temple visits. The service is suitable for devotees and families seeking convenient transportation and coordinated travel throughout the pilgrimage."
},
{
"name": "Pune Ashtavinayak Express Tour",
"description": "Choose Pune Ashtavinayak Express Tour for a compact pilgrimage itinerary with comfortable private transportation. The service is suitable for devotees with limited travel time who want an efficiently planned temple journey from Pune."
},
{
"name": "Pune Ashtavinayak 3-Day Package",
"description": "Book Pune Ashtavinayak 3-Day Package for a relaxed multi-day pilgrimage with private chauffeur-driven transportation. The extended schedule provides families, devotees, and groups with more flexibility for temple visits, rest stops, and sightseeing."
},
{
"name": "Ashtavinayak Three-Day Relaxed Tour",
"description": "Choose Ashtavinayak Three-Day Relaxed Tour for a comfortable pilgrimage itinerary spread across three days. The service is suitable for families, senior citizens, and devotees who prefer a less hurried journey with private transportation between temple destinations."
},
{
"name": "Pune Ashtavinayak 3 Days 2 Nights",
"description": "Book Pune Ashtavinayak 3 Days 2 Nights for an organized multi-day temple journey with comfortable private transportation. The service is suitable for families, groups, and devotees looking for a balanced itinerary covering pilgrimage destinations with convenient travel arrangements."
},
{
"name": "Ashtavinayak Package for Senior Citizens",
"description": "Choose Ashtavinayak Package for Senior Citizens for a comfortable pilgrimage journey designed around convenient transportation and flexible travel arrangements. Spacious vehicles and professional chauffeurs can make multi-temple travel more practical for senior devotees and their families."
},
{
"name": "Customized Ashtavinayak Itinerary from Pune",
"description": "Book a Customized Ashtavinayak Itinerary from Pune to plan temple visits according to your preferred schedule, travel duration, and group requirements. Private cab options allow families and devotees to organize their pilgrimage with flexible pickup, stops, and destination arrangements."
},
{
"name": "Pune Ashtavinayak Sedan Cab",
"description": "Choose Pune Ashtavinayak Sedan Cab for practical and comfortable transportation for couples, individuals, and small families. The AC sedan provides convenient seating and luggage space for temple visits and customized pilgrimage travel."
},
{
"name": "Pune Ashtavinayak Dzire Cab",
"description": "Book Pune Ashtavinayak Dzire Cab for economical and comfortable private transportation during your temple tour. The sedan is suitable for small families and devotees seeking practical AC travel for a planned Ashtavinayak journey."
},
{
"name": "Pune Ashtavinayak Ertiga Cab",
"description": "Choose Pune Ashtavinayak Ertiga Cab for spacious travel suitable for families and small groups. The vehicle offers practical seating and luggage capacity for temple visits, multi-day pilgrimage tours, and group transportation."
},
{
"name": "Pune Ashtavinayak Innova Cab",
"description": "Book Pune Ashtavinayak Innova Cab for comfortable and spacious transportation for families and pilgrimage groups. The vehicle is suitable for longer temple tours where passengers need convenient seating, luggage space, and private chauffeur service."
},
{
"name": "Pune Ashtavinayak Innova Crysta",
"description": "Choose Pune Ashtavinayak Innova Crysta for premium and spacious pilgrimage transportation with comfortable interiors and professional chauffeur service. It is suitable for families, senior passengers, executives, and groups seeking enhanced comfort during a multi-temple journey."
},
{
"name": "Pune Ashtavinayak SUV Cab",
"description": "Book Pune Ashtavinayak SUV Cab for spacious private travel with additional passenger and luggage capacity. The service is suitable for families and groups planning a longer pilgrimage journey across multiple Ashtavinayak temple destinations."
},
{
"name": "Pune Ashtavinayak 6-Seater Cab",
"description": "Choose Pune Ashtavinayak 6-Seater Cab for convenient group transportation with comfortable seating and luggage space. The vehicle is suitable for families and small groups traveling together for temple darshan and pilgrimage activities."
},
{
"name": "Pune Ashtavinayak 7-Seater Cab",
"description": "Book Pune Ashtavinayak 7-Seater Cab for spacious transportation for families and larger groups. The vehicle provides convenient seating and luggage capacity for multi-temple journeys, religious tours, and extended road travel."
},
{
"name": "Pune Ashtavinayak Tempo Traveller",
"description": "Choose Pune Ashtavinayak Tempo Traveller for group pilgrimage transportation with spacious seating and practical luggage arrangements. It is suitable for extended families, devotee groups, corporate groups, and organized temple tours."
},
{
"name": "Ashtavinayak Darshan 12-Seater Traveller",
"description": "Book Ashtavinayak Darshan 12-Seater Traveller for comfortable group transportation during a temple pilgrimage. The vehicle is suitable for larger families and devotee groups requiring shared private travel between multiple Ashtavinayak destinations."
},
{
"name": "Pune Ashtavinayak 17-Seater Traveller",
"description": "Choose Pune Ashtavinayak 17-Seater Traveller for larger group transportation during an organized pilgrimage. The spacious vehicle can accommodate groups traveling together for temple darshan, family tours, and religious events."
},
{
"name": "Pune Ashtavinayak Minibus",
"description": "Book Pune Ashtavinayak Minibus for convenient transportation of larger pilgrimage groups. The service provides spacious group travel for devotees, extended families, community groups, and organized religious tours visiting multiple temples."
},
{
"name": "Group Ashtavinayak Tour from Pune",
"description": "Choose Group Ashtavinayak Tour from Pune for private transportation suitable for families, friends, religious groups, and organized devotees. Larger vehicle options can be arranged according to group size, luggage, itinerary, and travel duration."
},
{
"name": "Luxury Ashtavinayak Cab Package",
"description": "Book Luxury Ashtavinayak Cab Package for premium pilgrimage transportation with enhanced comfort and refined vehicle interiors. The service is suitable for families, executives, senior passengers, and travelers seeking a more comfortable private temple tour."
},
{
"name": "Ganesh Chaturthi Ashtavinayak Tour",
"description": "Choose Ganesh Chaturthi Ashtavinayak Tour for convenient private transportation during the festive pilgrimage season. Comfortable vehicles can be arranged for devotees, families, and groups planning temple visits around Ganesh Chaturthi celebrations."
},
{
"name": "Pune Ashtavinayak Ganpati Festival Package",
"description": "Book Pune Ashtavinayak Ganpati Festival Package for private transportation to Ashtavinayak temples during the Ganpati festival period. The service is suitable for families and groups looking for organized travel with convenient pickup and temple-to-temple transportation."
},
{
"name": "Sankashti Chaturthi Ashtavinayak Cab",
"description": "Choose Sankashti Chaturthi Ashtavinayak Cab for comfortable private transportation during Sankashti Chaturthi temple visits. The service is suitable for devotees, families, and groups planning religious travel with flexible pickup and pilgrimage arrangements."
},
{
"name": "Angarki Chaturthi Ashtavinayak Tour",
"description": "Book Angarki Chaturthi Ashtavinayak Tour for convenient transportation during the special Angarki Chaturthi pilgrimage. Private cars and larger vehicles can be arranged for devotees and families traveling together for temple darshan."
},
{
"name": "Pune Ashtavinayak Weekend Yatra",
"description": "Choose Pune Ashtavinayak Weekend Yatra for a convenient short-duration pilgrimage from Pune. Comfortable chauffeur-driven vehicles make the journey suitable for families, devotees, and groups planning temple visits during a weekend."
},
{
"name": "Diwali Ashtavinayak Package from Pune",
"description": "Book Diwali Ashtavinayak Package from Pune for private pilgrimage transportation during the festive season. The service is suitable for families and groups planning temple visits around Diwali with comfortable vehicles and flexible travel arrangements."
},
{
"name": "New Year Ashtavinayak Tour",
"description": "Choose New Year Ashtavinayak Tour for a peaceful pilgrimage journey around the New Year period. Private chauffeur-driven vehicles can be arranged for families, friends, and devotees planning temple darshan and religious travel."
},
{
"name": "Monsoon Ashtavinayak Road Trip",
"description": "Book Monsoon Ashtavinayak Road Trip for a private temple journey during the rainy season with comfortable road transportation. The service is suitable for families, devotees, and groups who want flexible travel between Ashtavinayak destinations."
}
],
"tableData": [
["Pune to Ashtavinayak Cab", "Ashtavinayak Darshan Cab Pune"],
["Pune Ashtavinayak Taxi Service", "Cab for Ashtavinayak Yatra Pune"],
["Pune to Ashtavinayak Tour Cab", "Ashtavinayak Darshan Taxi Pune"],
["Pune Religious Cab Ashtavinayak", "Pune Temple Darshan Cab"],
["One Day Ashtavinayak Cab Pune", "Pune Pilgrimage Cab Ashtavinayak"],
["Best Ashtavinayak Cab Pune", "SUV Ashtavinayak Cab Pune"],
["Innova Ashtavinayak Cab Pune", "Sedan Ashtavinayak Cab Pune"],
["Ashtavinayak Yatra Booking Pune", "Pune to Ashtavinayak One-Day Trip"],
["One-Day Ashtavinayak Cab Package", "Ashtavinayak Darshan in One Day from Pune"],
["Pune Ashtavinayak Express Tour", "Pune Ashtavinayak 3-Day Package"],
["Ashtavinayak Three-Day Relaxed Tour", "Pune Ashtavinayak 3 Days 2 Nights"],
["Ashtavinayak Package for Senior Citizens", "Customized Ashtavinayak Itinerary from Pune"],
["Pune Ashtavinayak Sedan Cab", "Pune Ashtavinayak Dzire Cab"],
["Pune Ashtavinayak Ertiga Cab", "Pune Ashtavinayak Innova Cab"],
["Pune Ashtavinayak Innova Crysta", "Pune Ashtavinayak SUV Cab"],
["Pune Ashtavinayak 6-Seater Cab", "Pune Ashtavinayak 7-Seater Cab"],
["Pune Ashtavinayak Tempo Traveller", "Ashtavinayak Darshan 12-Seater Traveller"],
["Pune Ashtavinayak 17-Seater Traveller", "Pune Ashtavinayak Minibus"],
["Group Ashtavinayak Tour from Pune", "Luxury Ashtavinayak Cab Package"],
["Ganesh Chaturthi Ashtavinayak Tour", "Pune Ashtavinayak Ganpati Festival Package"],
["Sankashti Chaturthi Ashtavinayak Cab", "Angarki Chaturthi Ashtavinayak Tour"],
["Pune Ashtavinayak Weekend Yatra", "Diwali Ashtavinayak Package from Pune"],
["New Year Ashtavinayak Tour", "Monsoon Ashtavinayak Road Trip"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Ashtavinayak Darshan Cab for Pilgrimage Tours",
    WhyChoosedescription: "A dedicated cab makes it convenient for devotees and families to plan an Ashtavinayak Darshan journey from Pune, with travel arrangements suited to temple visits, group pilgrimages, and multi-destination religious tours."
  },
  {
    WhyChooseheading: "Convenient Pickup from Pune",
    WhyChoosedescription: "Devotees can start their pilgrimage from a preferred home, hotel, office, residential society, or another convenient location in Pune before beginning the temple circuit."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Groups",
    WhyChoosedescription: "Families, senior citizens, couples, and groups can select a suitable vehicle based on passenger count, luggage requirements, and comfort preferences for the multi-temple journey."
  },
  {
    WhyChooseheading: "Suitable for Complete Ashtavinayak Tours",
    WhyChoosedescription: "The private cab option allows travellers to organize transportation across the Ashtavinayak temples according to their preferred itinerary, darshan schedule, and available travel time."
  },
  {
    WhyChooseheading: "Flexible One-Way & Multi-Day Plans",
    WhyChoosedescription: "Depending on the pilgrimage requirement, passengers can arrange direct travel or plan a longer multi-day cab journey covering the temples and returning to Pune after completing the darshan."
  },
  {
    WhyChooseheading: "Helpful for Senior Citizens & Devotees",
    WhyChoosedescription: "Private transportation can be especially convenient for senior citizens and families who prefer travelling together without frequent vehicle changes during a religious tour."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Temple Darshan",
    WhyChoosedescription: "A round-trip arrangement provides transportation from Pune through the planned Ashtavinayak circuit and back, making it suitable for families and groups following a complete pilgrimage itinerary."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup point, preferred Ashtavinayak itinerary, travel dates, passenger count, luggage details, vehicle preference, and trip duration with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Ashtavinayak Darshan Cab Service?",
    answer: "Yes, Garud Cab Service provides private cab services from Pune for devotees and families planning Ashtavinayak Darshan tours, temple visits, religious trips, and multi-destination pilgrimages."
  },
  {
    question: "Can I book a cab for the complete Ashtavinayak Darshan?",
    answer: "Yes, a private cab can be arranged for a planned Ashtavinayak temple circuit according to your preferred itinerary, travel dates, darshan schedule, and trip duration."
  },
  {
    question: "Can I book a round-trip Ashtavinayak Darshan cab from Pune?",
    answer: "Yes, round-trip arrangements can be planned for travellers who want transportation from Pune through their selected temple circuit and back to Pune."
  },
  {
    question: "Is the Ashtavinayak cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to complete the pilgrimage together with convenient seating, luggage space, and flexible travel arrangements."
  },
  {
    question: "Is the service suitable for senior citizens?",
    answer: "Yes, private transportation can be a convenient option for senior citizens because the group can travel together without frequent changes between different vehicles."
  },
  {
    question: "Can I customize my Ashtavinayak Darshan itinerary?",
    answer: "Yes, the journey can be planned around your preferred temples, travel dates, darshan schedule, number of days, passenger requirements, and return plans."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I carry luggage during the Ashtavinayak tour?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be shared during booking."
  },
  {
    question: "Can I book a cab for a multi-day Ashtavinayak tour?",
    answer: "Yes, a private cab can be planned for a multi-day pilgrimage depending on your selected itinerary, travel duration, temple visits, and return requirements."
  },
  {
    question: "How can I book a Pune to Ashtavinayak Darshan Cab?",
    answer: "Share your Pune pickup location, preferred temple itinerary, travel dates, passenger details, luggage requirements, vehicle preference, and expected trip duration with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Pravin Joshi",
    feedback: "Our family planned an Ashtavinayak Darshan from Pune and selected a private cab for the complete pilgrimage. Travelling together made the multi-temple journey much easier to manage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Patil",
    feedback: "We arranged an Ashtavinayak trip with elderly family members. Having a private vehicle was convenient because we could travel together and plan the pilgrimage around our preferred schedule.",
    rating: 5
  }
];














  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-ashtavinayak-darshan-cab.webp",
  "description": "Book Pune to Ashtavinayak Darshan Cab with Garud Cab for a comfortable and convenient pilgrimage journey covering the famous Ashtavinayak temples of Maharashtra. Get dedicated cab and taxi services for Ashtavinayak Yatra from Pune with flexible tour planning, experienced drivers, and Sedan, Ertiga, SUV, Innova, and Innova Crysta options for family and group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-ashtavinayak-darshan-cab"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to Ashtavinayak Darshan Cab | Yatra Taxi Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Ashtavinayak Darshan Cab with Garud Cab for a comfortable and convenient temple tour. Get Ashtavinayak Yatra cab and taxi services from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for families and groups."
  />

  <meta
    name="keywords"
    content="Pune to Ashtavinayak Cab, Ashtavinayak Darshan Cab Pune, Pune Ashtavinayak Taxi Service, Cab for Ashtavinayak Yatra Pune, Pune to Ashtavinayak Tour Cab, Ashtavinayak Yatra Cab Pune, Ashtavinayak Darshan Taxi Pune, Ashtavinayak Tour Package from Pune, Pune Ashtavinayak Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakdarshancab;